




























































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import CustomStore from 'devextreme/data/custom_store';
import { ClientService } from '../../service/ClientService';
import { FeeSheetsService } from '../../service/FeeSheetsService';
import { FilingTypeService } from '../../service/FilingTypeService';
import DevExpress from 'devextreme/bundles/dx.all';
import { DataGrid } from '@questelservices/common-vue';
import { DxLoadPanel, DxButton, DxLookup, DxTooltip } from 'devextreme-vue';
import AddUpdateFeeSheets from  './add-update-fee-sheets.vue';
import FeeSheetEmailerWizards from  './fee-sheet-emailer-wizards.vue';
import AgentFeeSheetMassAdder from './agent-fee-sheet-mass-adder.vue';
import CreateFeeSheetFromTemplate from './create-fee-sheet-from-template.vue';
import {  
  DxColumn,
  DxEditing,
  DxForm,
  DxFormItem,
  DxHeaderFilter,
  DxPopup,
  DxStateStoring,
  DxPaging,
  DxPager
} from 'devextreme-vue/data-grid';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { ClientDto } from '../../models/client/ClientDto';
import { FeeSheetDto } from '@/models/Fees/FeeSheetDto';
import { FeeSheetModalFor, FeeSheetModalType } from '../../models/Fees/FeeTypeEnum';
import { FeeSheetTemplateDto } from '../../models/FeeSheetTemplates/FeeSheetTemplateDto';
import { FilingTypeDto } from '../../models/FilingTypeDto';
import _ from 'lodash';
import { SelectOption } from '@/models/SelectOption';

@Component({
  components: {    
    DataGrid,
    DxColumn,
    DxEditing,
    DxForm,
    DxFormItem,
    DxHeaderFilter, 
    DxLoadPanel,
    DxLookup,
    DxPopup,
    DxButton,
    DxStateStoring,
    DxPaging, 
    DxPager,
    AddUpdateFeeSheets,
    AgentFeeSheetMassAdder,
    CreateFeeSheetFromTemplate,
    FeeSheetEmailerWizards
  }
})
export default class ClientAgentsFeeSheets extends Vue {
    $refs: Vue['$refs'] & {
        agentDataGrid?: DataGrid;
        clientDataGrid?: DataGrid;
    } = {};

    dataGridUrl: string = '';    
    selectedClient: ClientDto = {
        ClientId: "",
        ClientName: ""
    }
    inJurisdictionCountriesFilter : Array<string> = [];
    private clientService : ClientService;    
    clientCustomStoreOptions: DevExpress.data.CustomStoreOptions;
    agentCustomStoreOptions: DevExpress.data.CustomStoreOptions;
    feeSheetsService: FeeSheetsService;
    showAddUpdateFeeSheet: boolean;
    showMassAgentSheetAdder: boolean;
    showCreateFromTemplate: boolean;
    showWizard: boolean;
    feeSheetData: FeeSheetDto;
    feeSheetFor: FeeSheetModalFor;
    feeSheetType: FeeSheetModalType;
    feeSheetTemplate: any = null;
    deletionInProgress: boolean = false;
    filingTypes: SelectOption[] = [];

    constructor() {
        super();
        this.loadData();
        this.feeSheetFor = FeeSheetModalFor.Client;
        this.feeSheetType = FeeSheetModalType.Add;
        this.showAddUpdateFeeSheet = false;
        this.showWizard = false;
        this.showMassAgentSheetAdder = false;
        this.showCreateFromTemplate = false;
        this.clientService = new ClientService();
        this.feeSheetsService = new FeeSheetsService('/api/FeeSheets');
        this.clientCustomStoreOptions = {};
        this.agentCustomStoreOptions = {};
        this.feeSheetData = {
            FeeSheetId: "",
            ClientId: "",
            AgentId: "",
            CurrencyId: 0,
            InJurisdiction: false,
            FeeSheetName: "",
            EffectiveDate: new Date(),
            FilingTypes: [],
            FilingTypesNamesString: "",
            FeeSheetRows: [],
            FeeSheetTitle: '',
            DeletedFeeSheetRows: [],
            Signed: "",
            Modified: false
        };

        
    }

    async loadData() {
        let filingTypeService = new FilingTypeService();

        let filingTypes = await filingTypeService.getTypes();

        this.filingTypes = filingTypes.map(f => {
            return  { 
                        value: f.Name, 
                        text: f.Name 
                    };
        })
    }

    clientStore: CustomStore = new CustomStore({
        loadMode: 'raw',
        load: (options): Promise<any> => {
        return this.clientService.getAll();
        }
    });

    private clientStoreOption(clientId: Guid) : any {
        return {
            key: 'FeeSheetId',
            load: (loadOptions: any) => this.feeSheetsService
                    .getClientFeeSheets(loadOptions,clientId)                    
                    .catch(err => [])
        };
    }

     private agentStoreOption(clientId: Guid) : any {
        return {
            key: 'FeeSheetId',
            load: (loadOptions: any) => this.feeSheetsService
                    .getAgentFeeSheets(loadOptions,clientId)
                    .then(result => {                       
                        let countries: Array<string> = [];
                        _.forEach(result.data, item => {
                            let list = item.InJurisdictionCountries ? item.InJurisdictionCountries.split(', ') : [];

                            countries = _.concat(countries, list);
                        });
                        this.inJurisdictionCountriesFilter = _.uniq(countries);                        
                        return result;
                    })
                    .catch(err => [])
        };
    }

    getPopupHeight(): number {
        return window.innerHeight / 1.5;
    }

    initNewRow(e: any) { }

    rowUpdating(e: any) { }

    dataGridInitialized(e: any): void { }
    
    hidingAddUpdateFeeSheet(updateData: boolean): void {        
        this.showAddUpdateFeeSheet = false;
        this.showWizard = false;

        if (updateData === true) {
            this.refreshDataGrids();
        }        
    }

    private cancelFeeSheet(): void {
        this.showAddUpdateFeeSheet = false;
        this.showWizard = false;
    }

    refreshDataGrids() : void {
        if (this.$refs.clientDataGrid) {
            (this.$refs.clientDataGrid as any).refreshDataGrid();
        }        
        
        if (this.$refs.agentDataGrid) {
            (this.$refs.agentDataGrid as any).refreshDataGrid();
        }
         
    }

    onEmailCampaignWizard(e: any): void {
        this.showWizard = true;
    }

    hidingCreateFromTemplate(template: FeeSheetTemplateDto): void {
        this.showCreateFromTemplate = false;
        
        if(template != null) {
            if(template.FeeSheetTemplateId == "") {                                
                this.feeSheetTemplate = null;                
            }
            else {                
                this.feeSheetTemplate = template;                
            }            
        }            
    }

    onAddUpdateFeeSheetClient(createClientSheet: boolean): void {
        if(createClientSheet) {
            this.feeSheetData.FeeSheetId = "";
            this.feeSheetFor = FeeSheetModalFor.Client;
            this.feeSheetType = FeeSheetModalType.Add;
            this.showAddUpdateFeeSheet = true;
        }        
    }
    onAddUpdateFeeSheetAgent(e: any): void {
        this.feeSheetData.FeeSheetId = "";
        this.feeSheetFor = FeeSheetModalFor.Agent;
        this.feeSheetType = FeeSheetModalType.Add;
        this.showAddUpdateFeeSheet = true;
    }

    onCreateFeeSheetFromTemplate(e: any): void {
        this.showCreateFromTemplate = true;
    }

    get getSelectedClient(): ClientDto {
        let empty: ClientDto = {
          ClientId: '',
          ClientName: ''
        };

        return this.selectedClient != null ? this.selectedClient : empty;
    }

    editBtnClicked(e: any): void {        
        this.feeSheetFor = FeeSheetModalFor.Client;
        this.feeSheetType = FeeSheetModalType.Update

        if(e.data.FilingTypeId == null) {
            e.data.FilingTypeId = -1;
        }
        this.feeSheetData = _.clone(e.data);
        this.showAddUpdateFeeSheet = true;
    }

    async deleteBtnClicked(sheet: FeeSheetDto) {
      let agents = await this.feeSheetsService.getAgentNamesWithParentFeeSheet(sheet.FeeSheetId);
      let message = `<p>Are you sure want to delete <b>${sheet.FeeSheetTitle}</b> for <b>${sheet.ClientName}</b>?</p>`;

      if (agents.length > 0) {
        let agentsString = agents.map(a => `<b>${a}</b>`).join(', ');
        message += `<p>This will also delete the associated agent sheets for:</p><p>${agentsString}</p>`;
      }

      let result = await confirm(message, 'Confirm Delete');
      if (result) {
        notify(`Deleting ${sheet.FeeSheetTitle}...`, 'info', 4000);
        this.deletionInProgress = true;
        this.feeSheetsService.deleteFeeSheet(sheet.FeeSheetId)
          .then(response => {
            notify(`${sheet.FeeSheetTitle} successfully deleted`, 'success', 4000);
            this.refreshDataGrids();
          })
          .catch(reason => {
            notify(`An error occurred deleting the fee sheet`, 'error', 4000);
          })
          .finally(() => {
            this.deletionInProgress = false;
          });
      }
    }

    agentEditBtnClicked(e:any) : void {
        this.feeSheetFor = FeeSheetModalFor.Agent;
        this.feeSheetType = FeeSheetModalType.Update;
        
        if(e.data.FilingTypeId == null) {
            e.data.FilingTypeId = -1;
        }
        this.feeSheetData = _.clone(e.data);
        this.showAddUpdateFeeSheet = true;
    }

    async agentDeleteBtnClicked(sheet: FeeSheetDto) {
      let message = `Are you sure you want to delete <b>${sheet.FeeSheetTitle}</b> for <b>${sheet.AgentName}</b>?`;
      let result = await confirm(message, 'Confirm Delete');
      if (result) {
        notify(`Deleting ${sheet.FeeSheetTitle}...`, 'info', 4000);
        this.deletionInProgress = true;
        this.feeSheetsService.deleteFeeSheet(sheet.FeeSheetId)
          .then(response => {
            notify(`${sheet.FeeSheetTitle} successfully deleted`, 'success', 4000);
            this.refreshDataGrids();
          })
          .catch(reason => {
            notify(`An error occurred deleting the fee sheet`, 'error', 4000);
          })
          .finally(() => {
            this.deletionInProgress = false;
          });
      }
    }

    clientAgents : any[] = [];
    async onSelectedClientChanged(e: any): Promise<void> {
        let val = e.selectedItem;
        if (val == null) {
          val = {
            ClientId: '',
            ClientName: ''
          };
        }

        if(val && val.ClientId) {
            this.clientCustomStoreOptions = this.clientStoreOption(val.ClientId);
            this.agentCustomStoreOptions = this.agentStoreOption(val.ClientId);
            this.clientAgents = await this.clientService.getAgentByClientId(val.ClientId);
        }
    }

    openAgentFeeSheetMassAdder() {
        this.showMassAgentSheetAdder = true;
    }

    hidingMassAdder() {
        this.showMassAgentSheetAdder = false;
        this.refreshDataGrids();
    }

    private signedFilters(data: any): void {        
        data.dataSource.postProcess = (results: any) => {            
            let withPartial: number = results.filter((r: { key: string|string[]; }) => r.key.includes('of')).length;
            
            if(withPartial > 0) {
                let newResult = results.filter(function(obj: any) {
                    return !obj.key.includes('of');
                });

                newResult.push({ text: 'Partial', value: 'Partial' });
                return newResult;
            }            
            
            return results;
        }
    }  

    private signedFiltersExpression(value: string, selectedFilterOperations: string, target: string): string[] {            
        if(target === 'headerFilter' && value === 'Partial') {
            return ['Signed', 'contains', 'of'];
        }
        
        return ['Signed', selectedFilterOperations, value];
    }

    private inJurisdictionCountriesDataSource(data: any) {
        data.dataSource.postProcess = (results: any) => {            
            results = this.inJurisdictionCountriesFilter.map(item => {
                var entry = {
                    "text" : item,
                    "value" : item
                }
                return entry;
            })          
            
            return results;
        }
    }
    filterTypeOption = 'contains';
    private inJurisdictionCountriesFiltersExpression(value: string, selectedFilterOperations: string, target: string): string[] {    
         if(target === 'headerFilter')     {
             return ['InJurisdictionCountries',this.filterTypeOption, value]
         }
        return ['InJurisdictionCountries', this.filterTypeOption, value];
    }

    private modifiedFilters(data: any): void {
        data.dataSource.postProcess = (results: any) => {               
            return results.map(function(r: any) {                
                if(r.value === true) {
                    return {key: true, value: true, text: 'Yes'};
                }
                else if(r.value === false) {
                    return {key: false, value: false, text: 'No'};                    
                }
            });            
        }
    }

    private filingTypesFilterExpression(value: string, selectedFilterOperations: string, target: string): string[] {                
        return ['FilingTypesNamesString', 'contains', value];
    }
}

